
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth"; 
// import { useAuth } from "../../context/AuthContext";
// import { useParams } from "react-router-dom";
// import "../../style/Perfil.css";

// export default function EstudiantePerfil() {
//   const { token } = useAuth();
//   const { id } = useParams(); // matricula_id

//   const [estudiante, setEstudiante] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!token || !id) return;

//     const fetchPerfil = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const { data } = await axios.get(`/perfil-estudiante/${id}`);

//         setEstudiante(data);
//       } catch (err) {
//         console.error("❌ Error perfil estudiante:", err);

//         setError(
//           err.response?.data?.message ||
//           "Error al cargar perfil del estudiante"
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPerfil();
//   }, [id, token]);

//   if (loading) return <p className="loading">⏳ Cargando perfil...</p>;
//   if (error) return <p className="error">{error}</p>;
//   if (!estudiante) return <p>Estudiante no encontrado</p>;

//   return (
//     <div className="perfil-container">

//       {/* HEADER */}
//       <div className="perfil-header">
//         <div className="perfil-avatar">
//           <span>
//             {estudiante.nombres_estudiante?.charAt(0).toUpperCase() || "?"}
//           </span>
//         </div>

//         <div className="perfil-nombre">
//           <h2>
//             {estudiante.nombres_estudiante}{" "}
//             {estudiante.apellidos_estudiante}
//           </h2>
//           <span className="badge">Estudiante</span>
//         </div>
//       </div>

//       {/* INFO */}
//       <div className="perfil-info">
//         <p><strong>Documento:</strong> {estudiante.documento_estudiante}</p>

//         {estudiante.correo_estudiante && (
//           <p><strong>Correo:</strong> {estudiante.correo_estudiante}</p>
//         )}

//         <p><strong>Edad:</strong> {estudiante.edad || "-"} años</p>

//         <p>
//           <strong>Grado:</strong> {estudiante.grado || "-"}° - Grupo{" "}
//           {estudiante.grupo || "-"}
//         </p>

//         <p>
//           <strong>Año lectivo:</strong>{" "}
//           {estudiante.anio_lectivo}
//           {estudiante.anio_activo ? " (Activo)" : ""}
//         </p>

//         <p>
//           <strong>Sede:</strong> {estudiante.sede_nombre || "Principal"}
//         </p>

//         <p>
//           <strong>Colegio:</strong> {estudiante.colegio}
//         </p>
//       </div>
//     </div>
//   );
// }


///

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { useParams } from "react-router-dom";
import "../../style/Perfil.css";


export default function EstudiantePerfil() {


  const { token, user } = useAuth();

  const { id } = useParams();


  const [estudiante, setEstudiante] = useState(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");




  useEffect(() => {


    if (!token || !id) {

      setLoading(false);

      return;

    }



    const cargarPerfil = async () => {


      try {


        setLoading(true);

        setError("");



        const config = {

          headers: {

            Authorization:
              `Bearer ${token}`,

            "X-Tenant-ID":
              user?.tenant_id ||
              user?.institucion_id ||
              "",


            "X-Sede-ID":
              user?.sede_id ||
              ""

          }

        };




        const response = await axios.get(

          `/perfil-estudiante/${id}`,

          config

        );



        console.log(
          "📚 PERFIL ESTUDIANTE:",
          response.data
        );



        /*
          Soporta ambas respuestas:

          1)
          {
             ok:true,
             estudiante:{}
          }

          2)
          {
             nombres_estudiante:"..."
          }

        */


        const data =
          response.data?.estudiante ||
          response.data;



        if (!data) {

          throw new Error(
            "No existe información del estudiante"
          );

        }



        setEstudiante(data);



      } catch(error){



        console.error(
          "❌ Error perfil estudiante:",
          error.response?.data || error
        );



        setError(

          error.response?.data?.message ||

          error.message ||

          "Error cargando perfil"

        );



        setEstudiante(null);



      } finally {


        setLoading(false);


      }


    };



    cargarPerfil();



  },[
    id,
    token,
    user
  ]);







  if (loading) {


    return (

      <p className="loading">

        ⏳ Cargando perfil...

      </p>

    );


  }




  if(error){


    return (

      <p className="error">

        {error}

      </p>

    );


  }





  if(!estudiante){


    return (

      <p className="error">

        Estudiante no encontrado

      </p>

    );


  }







  return (

    <div className="perfil-container">



      {/* ======================
          HEADER
      ====================== */}


      <div className="perfil-header">



        <div className="perfil-avatar">


          <span>


            {
              estudiante.nombres_estudiante
              ?.charAt(0)
              ?.toUpperCase()
              ||
              "?"
            }



          </span>



        </div>




        <div className="perfil-nombre">



          <h2>


            {
              estudiante.nombres_estudiante
            }


            {" "}


            {
              estudiante.apellidos_estudiante
            }



          </h2>



          <span className="badge">

            🎓 Estudiante

          </span>



        </div>




      </div>







      {/* ======================
          INFORMACIÓN
      ====================== */}



      <div className="perfil-info">



        <p>

          <strong>
            Documento:
          </strong>{" "}


          {
            estudiante.documento_estudiante
            ||
            "-"
          }


        </p>




        {
          estudiante.email_estudiante &&

          (

            <p>

              <strong>
                Correo:
              </strong>{" "}


              {
                estudiante.email_estudiante
              }


            </p>


          )

        }





        {
          estudiante.telefono_estudiante &&

          (

            <p>

              <strong>
                Teléfono:
              </strong>{" "}


              {
                estudiante.telefono_estudiante
              }


            </p>


          )

        }





        <p>

          <strong>
            Edad:
          </strong>{" "}


          {
            estudiante.edad
            ||
            "-"
          }


          {" años"}


        </p>







        <p>


          <strong>
            Grado:
          </strong>{" "}


          {
            estudiante.grado
            ||
            "-"
          }


          °


          {" - Grupo "}


          {
            estudiante.grupo
            ||
            "-"
          }



        </p>







        <p>


          <strong>
            Año lectivo:
          </strong>{" "}



          {
            estudiante.anio_lectivo
            ||
            "-"
          }



          {


            estudiante.anio_activo &&

            (

              <span>

                {" "}
                (Activo)

              </span>

            )


          }



        </p>







        <p>


          <strong>
            Sede:
          </strong>{" "}


          {
            estudiante.sede_nombre
            ||
            "Principal"
          }



        </p>








        <p>


          <strong>
            Colegio:
          </strong>{" "}


          {
            estudiante.colegio
            ||
            "-"
          }



        </p>





      </div>





    </div>

  );


}